<section id="app-add-new">
  <div class="add-new-header">
    <div class="add-new-title-block">
      <h4 class="add-new-title form-check-label text-uppercase">
        {{ title }}
      </h4>
      <div class="form-check form-switch d-inline-block">
        <input class="form-check-input d-inline-block"
               type="checkbox"
               id="flexSwitchCheckDefault"
               *ngIf="showToggle"
               [(checked)]="toggleStatus"
               (click)="toggleChange.emit($event.target.checked)" />
      </div>
    </div>

    <div class="add-new-actions primary-action-button">
      <button *ngIf="showAddButton"
              (click)="clickAddNew.emit()"
              type="button"
              class="btn btn-primary add-new-primary-btn">
        {{ buttonLabel }}
      </button>
    </div>

    <hr class="add-new-divider" />
  </div>
</section>